import { createRootRoute, Outlet, useRouter } from "@tanstack/react-router"
import React, { Suspense, useEffect } from "react"

import NotFound from "../components/Common/NotFound"

const loadDevtools = () =>
  Promise.all([
    import("@tanstack/react-router-devtools"),
    import("@tanstack/react-query-devtools"),
  ]).then(([routerDevtools, reactQueryDevtools]) => {
    return {
      default: () => (
        <>
          <routerDevtools.TanStackRouterDevtools />
          <reactQueryDevtools.ReactQueryDevtools />
        </>
      ),
    }
  })

const TanStackDevtools =
  process.env.NODE_ENV === "production" ? () => null : React.lazy(loadDevtools)

export const Route = createRootRoute({
  component: () => <RootComponent />,
  notFoundComponent: () => <NotFound />,
})

function RootComponent() {
  const router = useRouter()

  useEffect(() => {
    try {
      const path = window.location?.pathname ?? "/"
      const sp = new URLSearchParams(window.location?.search ?? "")
      const dashId = sp.get("dashId")
      if (dashId && (path === "/" || path === "")) {
        router.navigate({ to: "/", search: { dashId } })
      }
    } catch {}
  }, [router])

  return (
    <>
      <Outlet />
      <Suspense>
        <TanStackDevtools />
      </Suspense>
    </>
  )
}
